import notify from "devextreme/ui/notify";

export const handleNotificationMessage = (path, id, error, type) =>
  error
    ? notify(error, "error", 500)
    : notify(`${type} ${path} with id ${id}`, "info", 3000);
